import { render, staticRenderFns } from "./ContactCoordinatorModal.vue?vue&type=template&id=8347a90e&scoped=true&"
import script from "./ContactCoordinatorModal.vue?vue&type=script&lang=js&"
export * from "./ContactCoordinatorModal.vue?vue&type=script&lang=js&"
import style0 from "./ContactCoordinatorModal.vue?vue&type=style&index=0&id=8347a90e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8347a90e",
  null
  
)

export default component.exports